// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"d7f25d7aa9d9335bc613","339":"b57a46ab31c228f2633f"}[chunkId] + ".js";
};